import Head from 'next/head'
import { FC } from 'react'
import { useTranslation } from 'src/@legacy/@core/hooks/UserTranslation'

const FAQTags: FC = () => {
  const { translate } = useTranslation()
  const faqObject = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: translate('page_employer_headhunt_service:lp_how_much_is_your_service_fee'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: `<p>${translate('page_employer_headhunt_service:lp_we_charge_approximately')}</p>`
        }
      },
      {
        '@type': 'Question',
        name: translate('page_employer_headhunt_service:lp_how_you__guarantee'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: `<p>${translate('page_employer_headhunt_service:lp_if_candidates_stop_working')}</p>`
        }
      },
      {
        '@type': 'Question',
        name: translate('page_employer_headhunt_service:lp_what_is_your_uniqueness'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: `<p>${translate('page_employer_headhunt_service:lp_we_are_hrtech_company')}</p>`
        }
      },
      {
        '@type': 'Question',
        name: translate('page_employer_headhunt_service:lp_how_long_does_it_take_to_get_first_cv'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: `<p>${translate('page_employer_headhunt_service:lp_it_depends_on_position', {
            number: process.env.NEXT_PUBLIC_NUMBER_CANDIDATES
          })}</p>`
        }
      },
      {
        '@type': 'Question',
        name: translate('page_employer_headhunt_service:lp_is_freec_new_player'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: `<p>${translate('page_employer_headhunt_service:lp_yes_we_came_to_vn_market', {
            number_candidate: process.env.NEXT_PUBLIC_NUMBER_CANDIDATES,
            number_company: process.env.NEXT_PUBLIC_NUMBER_COMPANIES
          })}</p>`
        }
      },
      {
        '@type': 'Question',
        name: translate('page_employer_headhunt_service:lp_where_is_focus_area_of_freec'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: `<p>${translate('page_employer_headhunt_service:lp_we_are_strong_at_IT_field')}</p>`
        }
      }
    ]
  }
  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: `${JSON.stringify(faqObject)}` }} />
    </Head>
  )
}

export default FAQTags
